<div [class]="styleClass()">
  <div class="flex flex-col gap-2" [class]="titleClass">
    <div class="flex flex-row gap-2 items-center">
      <ng-content select="[slot='button-back-content']"></ng-content>
      <h1 class="title">{{ title }}</h1>
    </div>
    @if (description) {
    <p class="description">{{ description }}</p>
    }
  </div>
  <div class="" [class]="contentClass">
    <ng-content select="[slot='banner-content']"></ng-content>
  </div>
</div>